import { NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120 } from "@faire/web-api--source/indigofair/settings/NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120";

import { useAssignSetting } from "./__internal__/useSetting";

export const useAssignSettingLoggedInProductCategoryHubsRSCM2 = () =>
  useAssignSetting(NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120);
